import { Ng2StateDeclaration } from '@uirouter/angular';
import { AreaService } from '@fi-app/area/area.service';
import { FiTimeZonesService } from '@fi-shared/fi-shared-services/fi-time-zones.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AreaEditComponent } from '@fi-app/area/area-edit/area-edit.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';

export const FiAreaAddState: Ng2StateDeclaration = {
    name: FiStateNames.Area.Add,
    url: '/Add',
    views: {
        '@': {
            component: AreaEditComponent,
        },
    },
    resolve: {
        area: [AreaService, FiAreaAddStateResolve_area],
        countries: [FiCountryHelperService, FiAreaAddStateResolve_countries],
        timeZones: [FiTimeZonesService, FiAreaAddStateResolve_timeZones],
        pageTitle: [PageTitleService, 'area', FiAreaAddStateResolve_pageTitle],
    },
};

export function FiAreaAddStateResolve_area(areaService: AreaService) {
    return areaService.GetArea(0);
}

export function FiAreaAddStateResolve_countries(countryHelperService: FiCountryHelperService) {
    return countryHelperService.getCountryCodes();
}

export function FiAreaAddStateResolve_timeZones(fiTimeZonesService: FiTimeZonesService) {
    return fiTimeZonesService.getTimeZones();
}

export function FiAreaAddStateResolve_pageTitle(ccmPageTitle: PageTitleService, area) {
    return ccmPageTitle.setTitleByItem(area);
}
